export default "__VITE_ASSET__D_NJzGg7__"